export const ContainerQueryFallback = {
  prefix: 'container-query-fallback-',
  selectorPrefix: '#html :is(',
} as const;
